/**
 * CobrandTabContainer Styles
 *
 * Styled components for CobrandTabContainer organism.
 * Uses Marriott global design tokens for consistent spacing, colors, and responsive breakpoints.
 * Provides flexible layout supporting various configurations and child components.
 */

import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledCobrandTabContainer = styled.div`
  /* Remove default list styling for AEM container children */
  .override-container-style {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  /* Flag section container with responsive padding */
  .flag-section-container {
    /* Use global border radius token */
    border-radius: var(--t-cards-border-radius, ${toRem(14)});
    box-shadow: 0 ${toRem(2)} ${toRem(10)} ${baseVariables.shadows.boxShadowTile};
    /* Responsive padding using global breakpoints */
    /* Mobile first approach */
    padding: 0 ${toRem(24)};

    /* Tablet and above */
    @media ${baseVariables.mediaQuery.md} {
      padding: 0 ${toRem(60)};
    }

    /* Desktop and above */
    @media ${baseVariables.mediaQuery.lg} {
      padding: 0 ${toRem(96)};
    }

    /* Ensure content doesn't overflow */
    overflow: hidden;
    .override-container-style,
    .column-containers,
    .aem-container {
      padding-right: 0;
      padding-left: 0;
    }
  }

  /* AEM responsive grid customization */
  .aem-Grid {
    display: flex;
    flex-direction: column;
    gap: ${toRem(16)};
    width: 100%;
  }

  /* Tab container wrapper */
  .tab-container-wrapper {
    position: relative;
    width: 100%;
    /* Add smooth transitions for content changes */
    transition: opacity 0.2s ease-in-out;
  }
`;
